import { render, staticRenderFns } from "./ExaminationRequest.vue?vue&type=template&id=21617b39&scoped=true"
import script from "./ExaminationRequest.vue?vue&type=script&lang=js"
export * from "./ExaminationRequest.vue?vue&type=script&lang=js"
import style0 from "./ExaminationRequest.vue?vue&type=style&index=0&id=21617b39&prod&lang=css"
import style1 from "./ExaminationRequest.vue?vue&type=style&index=1&id=21617b39&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21617b39",
  null
  
)

export default component.exports